import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbersNegativeFloat]'
})
export class OnlyNumbersNegativeFloatDirective {

  constructor() { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    // const keyPressed = event.key;

    // // Permitir números del 0 al 9, el punto y las teclas permitidas
    // if (!/[\d-.]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
    //   event.preventDefault();
    // }

    // // Permitir solo un punto decimal en la entrada
    // if (keyPressed === '.' && (event.target as HTMLInputElement).value.includes('.')) {
    //   event.preventDefault();
    // }
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
  
    // Permitir números del 0 al 9, el punto y las teclas permitidas
    if (!/[\d.-]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
    }
  
    // Permitir solo un punto decimal en la entrada
    if (keyPressed === '.' && inputValue.includes('.')) {
      event.preventDefault();
    }
  
    // Permitir solo un signo negativo y solo si es el primer carácter
    if (keyPressed === '-' && (inputValue.includes('-') || input.selectionStart! > 0)) {
      event.preventDefault();
    }
  }
}
